export const truncate = (string: string, digits = 15) => {
  if (string.length > digits) {
    return `...${string.substring(string.length - digits)}`;
  }
  return string;
};
